<template>
  <div class="pill" :style="{ 'color': getColorClass(this.status).font, 'background-color': getColorClass(this.status).background }">
    {{ this.text }}
  </div>
</template>

<script>


  export default {
    name: "Pill",
    components:{
    },
    props:{
      text:{
        default: null,
      },
      status: {
        default: null,
      }
    },
    data(){
      return {
      }
    },
    mounted (){
    },
    created(){
    },
    methods : {
      getColorClass(status) {
        if (status === 'processing') {
          return {
            background: '#FCF0CF',
            font: '#F0B310'
          };
        }

        if (status === 'completed') {
          return {
            background: '#046AA2',
            font: '#FFFFFF'
          };
        }

        if (status === 'failed') {
          return {
            background: '#d75025',
            font: '#FFFFFF'
          };
        }

        return {
          background: '#E6E6E6',
          font: '#747171'
        };
      }
    }
  }
</script>
